import { render, staticRenderFns } from "./OrderSummaryMainPage.vue?vue&type=template&id=1505747f&scoped=true&"
import script from "./OrderSummaryMainPage.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryMainPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummaryMainPage.vue?vue&type=style&index=0&id=1505747f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1505747f",
  null
  
)

export default component.exports